import React from 'react';
import PropTypes from 'prop-types';
import {useIntl} from 'react-intl';
import {ActionFooter} from 'wobi-web-common/dist/v2/index.js';

function ArrowIcon({size = 18}) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
      <path d="M5 12h14" /><path d="M12 5l7 7-7 7" />
    </svg>
  );
}

function ArrowLeftIcon({size = 20}) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
      <path d="M19 12H5" /><path d="M12 19l-7-7 7-7" />
    </svg>
  );
}

/**
 * InsuredFooter — Back + Continue button bar. Sticky on mobile.
 * Travel-only component.
 */
const InsuredFooter = ({onBack, onNext, nextLabel, nextDisabled = false, backLabel}) => {
  const intl = useIntl();
  return <ActionFooter
    className='flow-footer'
    ariaLabel={intl.formatMessage({id: 'insuredFooter.ariaLabel'})}
    secondaryLabel={backLabel || intl.formatMessage({id: 'back'})}
    onSecondary={onBack}
    secondaryIconStart={<ArrowIcon size={18} />}
    primaryLabel={nextLabel || intl.formatMessage({id: 'continue'})}
    onPrimary={onNext}
    primaryDisabled={nextDisabled}
    primaryIconEnd={<ArrowLeftIcon size={20} />}
    primaryButtonProps={{'data-testid': 'continue-button-2'}}
    mobileSticky
  />;
};

InsuredFooter.propTypes = {
  onBack: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
  nextLabel: PropTypes.node,
  nextDisabled: PropTypes.bool,
  backLabel: PropTypes.node,
};

export default InsuredFooter;
